<template>
  <el-dialog
    :visible="visible"
    width="520px"
    custom-class="announcement-dialog"
    :show-close="false"
    :close-on-click-modal="false"
    :append-to-body="true"
    @update:visible="$emit('update:visible', $event)"
  >
    <section class="announcement-modal" :aria-labelledby="titleId">
      <header class="announcement-modal-header">
        <div class="announcement-modal-mark" aria-hidden="true"><i class="el-icon-bell"></i></div>
        <span class="announcement-modal-label"><span></span>{{ announcement.isRead ? '已读公告' : '未读公告' }}</span>
        <button
          class="announcement-modal-close"
          type="button"
          aria-label="关闭公告"
          @click="close"
        ><i class="el-icon-close" aria-hidden="true"></i></button>
      </header>
      <div class="announcement-modal-heading">
        <h2 :id="titleId">{{ announcement.title }}</h2>
        <p><i class="el-icon-time" aria-hidden="true"></i>{{ formatDate(announcement.updateTime || announcement.createTime) }}</p>
      </div>
      <div class="announcement-modal-body">
        <div class="announcement-modal-content">{{ announcement.content }}</div>
      </div>
      <footer class="announcement-modal-footer">
        <span><i class="el-icon-circle-check" aria-hidden="true"></i>公告已送达</span>
        <el-button type="primary" @click="close">
          我知道了<i class="el-icon-right" aria-hidden="true"></i>
        </el-button>
      </footer>
    </section>
  </el-dialog>
</template>

<script>
export default {
  name: 'AnnouncementDialog',
  props: {
    announcement: { type: Object, required: true },
    visible: { type: Boolean, default: false }
  },
  computed: {
    titleId() {
      return 'announcement-title-' + this._uid;
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    },
    formatDate(value) {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);
      return new Intl.DateTimeFormat('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(date);
    }
  }
};
</script>
